import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';

// TODO - update prop type to match a common CTA prop type
import { jsx as _jsx } from "react/jsx-runtime";
const LoadingCTA = ({
  block,
  use = 'primary'
}) => {
  return /*#__PURE__*/_jsx(LoadingButton, {
    use: use || 'primary',
    loading: true,
    margin: "0",
    block: block,
    children: /*#__PURE__*/_jsx("span", {
      "aria-hidden": true,
      children: "Loading"
    })
  });
};
export default LoadingCTA;